<!-- Footer type07: 3 cols - logo+slogan | quick links | contact (no IATA/ASATA) -->
<section class="flex flex-auto justify-center w-full">
    <footer class="bg-white w-full sm:mb-0 p-4 dark:bg-slate-900">
        <div class="w-full max-w-7xl mx-auto sm:px-6 md:px-8">
            <div class="grid grid-cols-1 md:grid-cols-3 gap-8 py-14 items-start">
                <!-- Col 1: Logo + Slogan -->
                <div class="flex flex-col justify-start items-center md:items-start text-center md:text-left">
                    @if(view.site) {
                    <a class="flex justify-center mb-5" [routerLink]="'/'">
                        @if(view.site?.id === 163 && view.site?.logoUrl2) {
                        <img class="w-60 rounded-lg" [alt]="view.site?.name" [src]="view.site?.logoUrl2">
                        } @else if (view.site?.logoUrl) {
                        <img class="w-100 rounded-lg" [alt]="view.site?.name" [src]="view.site?.logoUrl">
                        }
                    </a>
                    }
                    @if(view.site?.slogan) {
                    <p class="ml-1 text-primary-500 dark:text-white text-3xl font-secondary max-w-60 text-center">
                        {{view.site?.slogan}}
                    </p>
                    }
                </div>

                <!-- Col 2: Quick Links (same as navbar) -->
                <div class="w-full flex flex-col items-center justify-start text-center">
                    <h1 class="text-3xl tracking-wider mb-2">Quick Links</h1>
                    @if (view.site?.profile?.heading?.border == 1) {
                    <div class="flex items-baseline justify-center">
                        <span class="w-10 border-b-2 border-primary-500"></span>
                        <span class="w-3 ml-1 border-b-2 border-primary-500"></span>
                    </div>
                    }
                    <ul class="flex flex-col items-center mt-3 space-y-2">
                        @for(link of view.quickLinks; track link.link + link.title) {
                        <li class="w-full flex justify-center">
                            @if(link.externalLink) {
                            <a [href]="link.link" [attr.target]="link.target" rel="noopener noreferrer"
                                class="group relative inline-block text-primary-500 hover:text-accent transition-colors duration-300 uppercase">
                                {{ link.title }}
                                <span class="absolute left-0 bottom-0 w-full h-0.5 bg-accent scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></span>
                            </a>
                            } @else {
                            <a [routerLink]="link.link"
                                class="group relative inline-block text-primary-500 hover:text-accent transition-colors duration-300 uppercase">
                                {{ link.title }}
                                <span class="absolute left-0 bottom-0 w-full h-0.5 bg-accent scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></span>
                            </a>
                            }
                        </li>
                        }
                    </ul>
                </div>

                <!-- Col 3: Contact -->
                <div class="w-full flex flex-col items-center md:items-start justify-start text-center md:text-left">
                    <h1 class="text-3xl tracking-wider mb-2">Contact</h1>
                    @if (view.site?.profile?.heading?.border == 1) {
                    <div class="flex items-baseline justify-center md:justify-start">
                        <span class="w-10 border-b-2 border-primary-500"></span>
                        <span class="w-3 ml-1 border-b-2 border-primary-500"></span>
                    </div>
                    }
                    <ul class="flex flex-col items-center md:items-start mt-3 space-y-3">
                        @if(view.site?.address) {
                        <li class="text-primary-500">
                            <a class="flex items-center">
                                <mat-icon class="icon-size-5 text-accent mr-3" svgIcon="heroicons_outline:map"></mat-icon>
                                {{ view.site?.address }}
                            </a>
                        </li>
                        }
                        @if(view.site?.telephone) {
                        <li class="text-primary-500">
                            <a class="flex items-center">
                                <mat-icon class="icon-size-5 text-accent mr-3" svgIcon="heroicons_outline:phone"></mat-icon>
                                {{ view.site?.telephone }}
                            </a>
                        </li>
                        }
                        @if(view.site?.emailAddress) {
                        <li class="text-primary-500 cursor-pointer">
                            <a [href]="view.emailLink" class="flex items-center">
                                <mat-icon class="icon-size-5 text-accent mr-3" svgIcon="heroicons_outline:envelope"></mat-icon>
                                {{ view.site?.emailAddress }}
                            </a>
                        </li>
                        }
                    </ul>
                </div>
            </div>

            <div class="py-7 border-t border-gray-200">
                <div class="flex items-center justify-center flex-col lg:justify-between lg:flex-row">
                    <p class="text-sm text-center text-gray-500 dark:text-white">© Copyright &copy; {{currentYear}}
                        <span class="mx-1 text-primary-500">TravelFind.Me</span>(Pty) Ltd. All rights reserved.
                    </p>
                    @if(view.pages && view.site?.id !== 58) {
                    <ul class="flex items-center gap-9 mt-4 lg:mt-0">
                        @for(page of view.pages; track page) {
                        <li><a [routerLink]="['/policy', page.seo.alias]"
                                class="text-sm text-gray-500 dark:text-white hover:text-primary-500">{{page.name}}</a>
                        </li>
                        }
                    </ul>
                    }
                </div>
            </div>
        </div>
    </footer>
</section>
